<template>
	<PublicMenuLayoutV2 showInstallAppButton>
		<template v-slot:nav-items>
			<b-nav-item @click="goToOpensalud4allLanding" v-if="!inMx">
				<p>Opensalud4all</p>
			</b-nav-item>
			<b-nav-item @click="goToMenttum" v-if="!inMx">
				<p>Menttum</p>
			</b-nav-item>
		</template>
		<template v-slot:nav-btn-items>
			<b-nav-item class="my-auto d-none d-landscape-block ml-portrait-0 ml-portrait-2">
				<router-link to="/inicio-sesion">
					<ArrowButton :text="$t('login-wrd')" :action="() => { $router.push('/inicio-sesion') }" reverse :backgroundColor="BLUE_COLOUR" :textColor="WHITE_COLOUR"/>
				</router-link>
			</b-nav-item>
		</template>
	</PublicMenuLayoutV2>
</template>

<script>
	import PublicMenuLayoutV2 from '@/components/layouts/PublicMenuLayoutV2'
	import ArrowButton from '@/components/base/buttons/ArrowButton'
	import { BNavItem } from 'bootstrap-vue'
	import { BLUE_COLOUR, WHITE_COLOUR } from '@/constants/colours'

	export default {
		name: 'OpensaludLayout',
		components: {
			BNavItem,
			PublicMenuLayoutV2,
			ArrowButton
		},
		data () {
			return {
				BLUE_COLOUR,
				WHITE_COLOUR
			}
		},
		methods: {
			goToOpensalud4allLanding () {
				window.location = 'https://opensalud4all.com/'
			},
			goToMenttum () {
				window.location = 'https://menttum.com/'
			}
		}
	}
</script>

<style lang="scss" scoped>
/deep/p {
	margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/OpensaludLayout.vue